<template>
  <ul id="list-tasks">
    <li>
      <div id='registro'>
        <div id="headerList-comprobante" class="textHeaderList" style="width: 20%">{{item.CodigoComprobante}}</div>
        <div id="headerList-tipo" class="textHeaderList" style="width: 20%">{{tipo(item.Tipo)}}</div>
        <div id="headerList-fecha" class="textHeaderList" style="width: 14%">{{moment(item.Fecha).format('DD/MM/YYYY')}}</div>
        <div id="headerList-vencimiento" class="textHeaderList" style="width: 14%">{{moment(item.FechaVencimiento).format('DD/MM/YYYY')}}</div>
        <div id="headerList-monto" class="textHeaderList" style="width: 15%">$ {{item.Importe | formatMoney}}</div>
        <div id="headerList-saldo" :class="{saldoPos:item.Saldo>0,saldoNeg:item.Saldo<0,saldoNeutro:item.Saldo==0}" style="width: 15%">$ {{item.Saldo | formatMoney}}</div>
        <div id="headerList-ver" class="textHeaderList" style="width: 6%" @click="btnVerDetalle"><img id="iconVer" src="/dist/icon-ver.png"></div>
      </div>
      <div  class="separator" style="width: 100%; height: 1px; background-color: #dddddd;" >  </div>
    </li>
  </ul>
</template>

<script>
import moment from 'moment'
import comprobante from '@components/views/ctacte/comprobante.vue'

export default {
  name: "item-cc",
  props: ["item"],
  methods: {
    tipo (key) {
      switch (key) {
        case 1:
          return 'FACTURA'
          break;
        case 2:
          return 'NOTA DE CREDITO'
          break;
        case 3:
          return 'NOTA DE DEBITO'
          break;
        case 4:
          return 'RECIBO'
          break;
      }
    },
    moment,
    btnVerDetalle() {
      this.$store.commit('modal/with', { view: comprobante, value: this.item })
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}

#registro {
  width: 650px;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: #ffffff;
}

.textHeaderList {
  color: #656e76;
  font-size: 10px;
  font-weight: 500;
}

.saldoPos {
  color: #04b590;
  font-size: 10px;
  font-weight: 500;
}

.saldoNeg {
  color: #e34860;
  font-size: 10px;
  font-weight: 500;
}

.saldoNeutro {
  color: #4969b2;
  font-size: 10px;
  font-weight: 500;
}

.checkContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

#iconVer {
  width: 15px;
  height: 15px;
}

#iconVer:hover {
  cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// src/components/views/ctacte/item.vue